var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CustomerList"},[_c('div',{staticClass:"pictrue"},[_c('img',{attrs:{"src":_vm.indexList.service_code}})]),_c('div',{staticClass:"text line1"},[_vm._v("迷迭商城客服24小时为您服务！")])])}
var staticRenderFns = []

export { render, staticRenderFns }